<template lang="pug">
.m-card.fight-game.mario
  .m-card-header-wrapper(
    :data-bs-toggle="source.items[0].marketId != 3 ? 'collapse' : null"
    :href="source.items[0].marketId != 3 ? '#collapse-match-' + index + source.items[0].marketId : null"
    role='button'
    :aria-expanded="source.items[0].marketId == 3 ? 'true' : 'false'"
    :aria-controls="'collapse-match-' + index + source.items[0].marketId"
  )
    efTimer(:source="source.items[0]")
    .mainmarket-item-match
      .team1
        img.characters.c1(:src="getImage(source.items[0].sportsId, source.items[7].matchBody[22])")
        img.characters.c2(:src="getImage(source.items[0].sportsId, source.items[6].matchBody[22])")
        span.name {{ source.items[0].homeTeam }}
      .vs
        img.img-fluid(src='images/vgame/vs.svg')
      .team2
        img.characters.c1(:src="getImage(source.items[0].sportsId, source.items[8].matchBody[23])")
        img.characters.c2(:src="getImage(source.items[0].sportsId, source.items[9].matchBody[23])")
        span.name {{ source.items[0].awayTeam }}
  .m-card-body.collapse.show(
    v-if="source.items[0].marketId != 3"
    :id="'collapse-match-' + index + source.items[0].marketId"
  )
    .m-card-item
      .m-card-wrap
        .m-group
          .section.winners-market
            .odds-group
              .col <!-- Home Team -->
                .team-group.team1.justify-content-center
                  span  {{ source.items[0].homeTeam }}
                .row 
                  template(v-if="checkBool(source, 0, 'ml', 0, 5)")  <!-- Team Win -->
                    OddsItem(:odds="source.items[0].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="ML_TW")
                  template(v-else)
                    OddsDisabled
                .row
                  template(v-if="checkBool(source, 0, 'cs', 3, 5)")  <!-- 3-0 -->
                    OddsItem.col(:odds="source.items[0].details['cs'][3]" idx=5 :typ="oddsType" dataType="3" label="CS_3_0")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 0, 'cs', 2, 5)")  <!-- 2-1 -->
                    OddsItem.col(:odds="source.items[0].details['cs'][2]" idx=5 :typ="oddsType" dataType="3" label="CS_2_1")
                  template(v-else)
                    OddsDisabled.col
                .row 
                  template(v-if="checkBool(source, 10, 'ml', 0, 5)")  <!-- Round 1 Winner -->
                    OddsItem.col(:odds="source.items[10].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="R_1_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 11, 'ml', 0, 5)")  <!-- Round 2 Winner -->
                    OddsItem.col(:odds="source.items[11].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="R_2_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 12, 'ml', 0, 5)")  <!-- Round 3 Winner -->
                    OddsItem.col(:odds="source.items[12].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="R_3_W")
                  template(v-else)
                    OddsDisabled.col
                .row
                  template(v-if="checkBool(source, 1, 'ou', 0, 12)")  <!-- Over -->
                    OddsItem.col(:odds="source.items[1].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="O" count=0 :details="source.items[1].details" homeAway="1")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 1, 'ou', 0, 11)")     <!-- Under -->
                    OddsItem.col(:odds="source.items[1].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="U" count=0 :details="source.items[1].details" homeAway="1")
                  template(v-else)
                    OddsDisabled.col
                .row
                  template(v-if="checkBool(source, 2, 'oe', 0, 7)")   <!-- Even -->
                    OddsItem.col(:odds="source.items[2].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="OE2")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 2, 'oe', 0, 5)")    <!-- Odd --> 
                    OddsItem.col(:odds="source.items[2].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="OE1")
                  template(v-else)
                    OddsDisabled.col
                    
              .col <!-- Away Team -->
                .team-group.team2.justify-content-center
                  span  {{ source.items[0].awayTeam }}
                .row
                  template(v-if="checkBool(source, 0, 'ml', 0, 7)")  <!-- Team Win -->
                    OddsItem(:odds="source.items[0].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="ML_TW")
                  template(v-else)
                    OddsDisabled
                .row 
                  template(v-if="checkBool(source, 0, 'cs', 2, 5)")  <!-- 2-1 -->
                    OddsItem.col(:odds="source.items[0].details['cs'][2]" idx=5 :typ="oddsType" dataType="3" label="CS_2_1")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 0, 'cs', 3, 5)")  <!-- 3-0 -->
                    OddsItem.col(:odds="source.items[0].details['cs'][3]" idx=5 :typ="oddsType" dataType="3" label="CS_3_0")
                  template(v-else)
                    OddsDisabled.col
                .row 
                  template(v-if="checkBool(source, 10, 'ml', 0, 7)")  <!-- Round 1 Winner -->
                    OddsItem.col(:odds="source.items[10].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="R_1_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 11, 'ml', 0, 7)")  <!-- Round 2 Winner -->
                    OddsItem.col(:odds="source.items[11].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="R_2_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 12, 'ml', 0, 7)")  <!-- Round 3 Winner -->
                    OddsItem.col(:odds="source.items[12].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="R_3_W")
                  template(v-else)
                    OddsDisabled.col
                .row
                  template(v-if="checkBool(source, 2, 'ou', 0, 11)")     <!-- Under -->
                    OddsItem.col(:odds="source.items[2].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="U" count=0 :details="source.items[2].details" homeAway="2")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 2, 'ou', 0, 12)")  <!-- Over -->
                    OddsItem.col(:odds="source.items[2].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="O" count=0 :details="source.items[2].details" homeAway="2")
                  template(v-else)
                    OddsDisabled.col
                .row
                  template(v-if="checkBool(source, 1, 'oe', 0, 5)")    <!-- Odd --> 
                    OddsItem.col(:odds="source.items[1].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="OE1")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 1, 'oe', 0, 7)")   <!-- Even -->
                    OddsItem.col(:odds="source.items[1].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="OE2")
                  template(v-else)
                    OddsDisabled.col
          .section.winners-market
            .odds-group
              .col <!-- Home Team -->
                .team-group.team1
                  img.characters(:src="getImage(source.items[0].sportsId, source.items[6].matchBody[22])")
                  span  {{ source.items[6].homeTeam }}
                .row 
                  template(v-if="checkBool(source, 3, 'cs', 0, 5)") <!-- Round 1 Winner - P1 -->
                    OddsItem.col(:odds="source.items[3].details['cs'][0]" idx=5 :typ="oddsType" dataType="3" label="R_1_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 4, 'cs', 0, 5)")  <!-- Round 2 Winner - P1 -->
                    OddsItem.col(:odds="source.items[4].details['cs'][0]" idx=5 :typ="oddsType" dataType="3" label="R_2_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 5, 'cs', 0, 5)")  <!-- Round 3 Winner - P1 -->
                    OddsItem.col(:odds="source.items[5].details['cs'][0]" idx=5 :typ="oddsType" dataType="3" label="R_3_W")
                  template(v-else)
                    OddsDisabled.col
              .col <!-- Home Team -->
                .team-group.team1
                  img.characters(:src="getImage(source.items[0].sportsId, source.items[7].matchBody[22])")
                  span  {{ source.items[7].homeTeam }}
                .row 
                  template(v-if="checkBool(source, 3, 'cs', 1, 5)") <!-- Round 1 Winner - P2 -->
                    OddsItem.col(:odds="source.items[3].details['cs'][1]" idx=5 :typ="oddsType" dataType="3" label="R_1_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 4, 'cs', 1, 5)")  <!-- Round 2 Winner - P2 -->
                    OddsItem.col(:odds="source.items[4].details['cs'][1]" idx=5 :typ="oddsType" dataType="3" label="R_2_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 5, 'cs', 1, 5)")  <!-- Round 3 Winner - P2 -->
                    OddsItem.col(:odds="source.items[5].details['cs'][1]" idx=5 :typ="oddsType" dataType="3" label="R_3_W")
                  template(v-else)
                    OddsDisabled.col
            .odds-group
              .col <!-- Away Team -->
                .team-group.team2
                  img.characters(:src="getImage(source.items[0].sportsId, source.items[8].matchBody[23])")
                  span.name {{ source.items[8].awayTeam }}
                .row 
                  template(v-if="checkBool(source, 3, 'cs', 2, 5)") <!-- Round 1 Winner - P3 -->
                    OddsItem.col(:odds="source.items[3].details['cs'][2]" idx=5 :typ="oddsType" dataType="3" label="R_1_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 4, 'cs', 2, 5)")  <!-- Round 2 Winner - P3 -->
                    OddsItem.col(:odds="source.items[4].details['cs'][2]" idx=5 :typ="oddsType" dataType="3" label="R_2_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 5, 'cs', 2, 5)")  <!-- Round 3 Winner - P3 -->
                    OddsItem.col(:odds="source.items[5].details['cs'][2]" idx=5 :typ="oddsType" dataType="3" label="R_3_W")
                  template(v-else)
                    OddsDisabled.col
              .col <!-- Away Team -->
                .team-group.team2
                  img.characters(:src="getImage(source.items[0].sportsId, source.items[9].matchBody[23])")
                  span.name {{ source.items[9].awayTeam }}
                .row 
                  template(v-if="checkBool(source, 3, 'cs', 3, 5)") <!-- Round 1 Winner - P4 -->
                    OddsItem.col(:odds="source.items[3].details['cs'][3]" idx=5 :typ="oddsType" dataType="3" label="R_1_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 4, 'cs', 3, 5)")  <!-- Round 2 Winner - P4 -->
                    OddsItem.col(:odds="source.items[4].details['cs'][3]" idx=5 :typ="oddsType" dataType="3" label="R_2_W")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 5, 'cs', 3, 5)")  <!-- Round 3 Winner - P4 -->
                    OddsItem.col(:odds="source.items[5].details['cs'][3]" idx=5 :typ="oddsType" dataType="3" label="R_3_W")
                  template(v-else)
                    OddsDisabled.col
          .section.best-market
            .m-label-top {{ $t("m.MA_T_3_R") }}
            .odds-group
              .col
                .row 
                  template(v-if="checkBool(source, 6, 'ml', 0, 5)")  <!-- Any Win Rounds - P1 -->
                    OddsItem.col(:odds="source.items[6].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="ANY_W_R")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 6, 'ml', 0, 7)")  <!-- No Win Rounds - P1 -->
                    OddsItem.col(:odds="source.items[6].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="NO_W_R")
                  template(v-else)
                    OddsDisabled.col
                .row 
                  template(v-if="checkBool(source, 7, 'ml', 0, 5)") <!-- Any Win Rounds - P2 -->
                    OddsItem.col(:odds="source.items[7].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 7, 'ml', 0, 7)")  <!-- No Win Rounds - P2 -->
                    OddsItem.col(:odds="source.items[7].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled.col
              .col
                .row 
                  template(v-if="checkBool(source, 8, 'ml', 0, 5)")  <!-- Any Win Rounds - P3 -->
                    OddsItem.col(:odds="source.items[8].details['ml'][0]" idx=5 :typ="oddsType" dataType="2" label="ANY_W_R")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 8, 'ml', 0, 7)")  <!-- No Win Rounds - P3 -->
                    OddsItem.col(:odds="source.items[8].details['ml'][0]" idx=7 :typ="oddsType" dataType="2" label="NO_W_R")
                  template(v-else)
                    OddsDisabled.col
                .row 
                  template(v-if="checkBool(source, 9, 'ml', 0, 5)") <!-- Any Win Rounds - P4 -->
                    OddsItem.col(:odds="source.items[9].details['ml'][0]" idx=5 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled.col
                  template(v-if="checkBool(source, 9, 'ml', 0, 7)")  <!-- No Win Rounds - P4 -->
                    OddsItem.col(:odds="source.items[9].details['ml'][0]" idx=7 :typ="oddsType" dataType="2")
                  template(v-else)
                    OddsDisabled.col
            .odds-group
              .col
                .row 
                  template(v-if="checkBool(source, 6, 'cs', 0, 5)")  <!-- Win 1 - P1 -->
                    OddsItem.col(:odds="source.items[6].details['cs'][0]" idx=5 :typ="oddsType" dataType="3" label="W_1")
                  template(v-else)
                    OddsDisabled.col        
                  template(v-if="checkBool(source, 6, 'cs', 1, 5)")  <!-- Win 2 - P1 -->
                    OddsItem.col(:odds="source.items[6].details['cs'][1]" idx=5 :typ="oddsType" dataType="3" label="W_2")
                  template(v-else)
                    OddsDisabled.col  
                  template(v-if="checkBool(source, 6, 'cs', 2, 5)") <!-- Prefect - P1 -->
                    OddsItem.col(:odds="source.items[6].details['cs'][2]" idx=5 :typ="oddsType" dataType="3" label="PF")
                  template(v-else)
                    OddsDisabled.col      
                .row 
                  template(v-if="checkBool(source, 7, 'cs', 0, 5)")  <!-- Win 1 - P2 -->
                    OddsItem.col(:odds="source.items[7].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled.col        
                  template(v-if="checkBool(source, 7, 'cs', 1, 5)")  <!-- Win 2 - P2 -->
                    OddsItem.col(:odds="source.items[7].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled.col  
                  template(v-if="checkBool(source, 7, 'cs', 2, 5)") <!-- Prefect - P2 -->
                    OddsItem.col(:odds="source.items[7].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled.col      
              .col
                .row 
                  template(v-if="checkBool(source, 8, 'cs', 0, 5)")  <!-- Win 1 - P3 -->
                    OddsItem.col(:odds="source.items[8].details['cs'][0]" idx=5 :typ="oddsType" dataType="3" label="W_1")
                  template(v-else)
                    OddsDisabled.col        
                  template(v-if="checkBool(source, 8, 'cs', 1, 5)")  <!-- Win 2 - P3 -->
                    OddsItem.col(:odds="source.items[8].details['cs'][1]" idx=5 :typ="oddsType" dataType="3" label="W_2")
                  template(v-else)
                    OddsDisabled.col  
                  template(v-if="checkBool(source, 8, 'cs', 2, 5)") <!-- Prefect - P3 -->
                    OddsItem.col(:odds="source.items[8].details['cs'][2]" idx=5 :typ="oddsType" dataType="3" label="PF")
                  template(v-else)
                    OddsDisabled.col           
                .row 
                  template(v-if="checkBool(source, 9, 'cs', 0, 5)")  <!-- Win 1 - P4 -->
                    OddsItem.col(:odds="source.items[9].details['cs'][0]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled.col        
                  template(v-if="checkBool(source, 9, 'cs', 1, 5)")  <!-- Win 2 - P4 -->
                    OddsItem.col(:odds="source.items[9].details['cs'][1]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled.col  
                  template(v-if="checkBool(source, 9, 'cs', 2, 5)") <!-- Prefect - P4 -->
                    OddsItem.col(:odds="source.items[9].details['cs'][2]" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled.col         
             
</template>

<script>
import config from "@/config";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    efTimer: () => import("@/components/mobile/efight/efTimer"),
    OddsItem: () => import("@/components/mobile/main/xitem/oddsItem"),
    OddsDisabled: () => import("@/components/mobile/main/xitem/oddsDisabled")
  },
  mixins: [mixinHDPOUOdds],
  props: {
    source: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: { 
    oddsType() {
      return this.$store.getters.pageDisplay.oddsType;
    },
    racingList(){
      return config.racingList;
    },
    newFeatures() {
      return config.newFeatures;
    }
   },
  methods: {
    team(player, pos, isTeam) {
      if(isTeam) {
        var n = player.homeTeam;
        return n;
      } else {
        var n = player.homeTeam.split(" - ")[pos];
        return n;
      }
    },
    getImage(s, img) {
      // return config.resourceImgUrl + "/ef/uat/" + s + "/" +img+ ".png"; 
      return config.resourceImgUrl + "/ef/" + (this.newFeatures ? 'uat/' : 'prod/') + s + "/" + img + ".png";
    },
    checkBool(source,source_index, key, key_index, child){
      return source.items[source_index] && source.items[source_index].details[key] && 
      source.items[source_index].details[key][key_index] && source.items[source_index].details[key][key_index][child] != 0 && 
      source.items[source_index].details[key][key_index][child] != ''
    },
  }
};
</script>